import { render, staticRenderFns } from "./BosquesTerrenos.vue?vue&type=template&id=e7463308"
import script from "./BosquesTerrenos.vue?vue&type=script&lang=js"
export * from "./BosquesTerrenos.vue?vue&type=script&lang=js"
import style0 from "./BosquesTerrenos.vue?vue&type=style&index=0&id=e7463308&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports